<div>
    <mat-card appearance="outlined" class="default-card">
        <mat-card-header>
            <mat-card-title>Ajout de fichier(s)</mat-card-title>
            <div class="mat-card-header-buttons">
                <button
                    mat-mini-fab
                    class="basic-button small"
                    [disabled]="uploader?.queue?.length > 50"
                    aria-label="Attacher un fichier"
                    matTooltip="Sélection d'un fichier"
                    matTooltipPosition="below"
                    (click)="fileToUpload.click()">
                    <fa-icon [icon]="uploadIcon"></fa-icon>
                </button>
            </div>
        </mat-card-header>
        <mat-card-content>
            <div class="container" ng2FileDrop [uploader]="uploader" (fileOver)="fileOver($event)" [ngClass]="{ 'file-over': fileDropZoneOver }">
                <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" [hidden]="true" multiple="multiple" />

                @if (uploader.queue.length !== 0) {
                    <table class="table-add-file">
                        <thead>
                            <tr>
                                <th>Nom du Fichier</th>
                                <th width="100px">Taille</th>
                                <th width="30px"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (item of uploader.queue; track item) {
                                <tr>
                                    <td class="fileName">{{ item?.file?.name }}</td>
                                    <td width="100px">{{ item?.file?.size | avmFileSize }}</td>
                                    <td width="30px">
                                        <mat-icon (click)="item.remove()">delete</mat-icon>
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                } @else {
                    <p class="empty-text">Aucun fichier sélectionné</p>
                }

                <div class="form-item">
                    <mat-form-field class="mat-form-field-comment">
                        <mat-label>Libellé du document qui contiendra le(s) fichier(s)</mat-label>
                        <input matInput appOnKeyEnterEvent (enter)="validate()" [formControl]="commentFormControl" autocomplete="off" />
                    </mat-form-field>
                </div>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
            <button mat-raised-button class="accent-button" [disabled]="uploader.queue.length === 0" (click)="upload()">Valider</button>
        </mat-card-actions>
    </mat-card>
    <ngx-spinner name="add-file-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</div>
